import React, { Component } from 'react';
import Checked from './components/Checked'
import Unchecked from './components/Unchecked'
import Disabled from './components/Disabled'
import FontSize from './components/FontSize'
import Controlled from './components/Controlled'
import FontSizeUsingCss from './components/FontSizeUsingCss'
import Attribute from './components/Attribute'
import HandleChange from './components/HandleChange'
import AsyncHandleChange from './components/AsyncHandleChange'
import HandleClick from './components/HandleClick'
import ToggleIcon from './components/ToggleIcon'
import OnOffIcon from './components/OnOffIcon'
import OnOffColor from './components/OnOffColor'
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="container">
        <h2 className="heading">React Toggles</h2>
        <p className="info">A decently configurable set of 3 toggle buttons which can be directly used anywhere without including any external css.</p>
        <p>Below are a few examples to demonstrate different configuration options and different set of prop values.</p>
        <h4 id="defaultchecked">Default Checked :<code>checked</code></h4>
        <Checked />
        <h4 id="defaultunchecked">Default Unchecked</h4>
        <Unchecked />
        <h4 id="disabled">Disabled :<code>disabled</code></h4>
        <Disabled />
        <h4 id="fontsize">Setting font size :<code>fontSize</code></h4>
        <FontSize />
        <h4 id="cssfontsize">Setting font size using css</h4>
        <FontSizeUsingCss />
        <h4 id="controlled">As controlled element :<code>checked</code></h4>
        <Controlled />
        <h4 id="attributes">Passing attribute : <code>attributes</code></h4>
        <Attribute />
        <h4 id="handlechange">Handle change event listener :<code>handleChange</code></h4>
        <HandleChange />
        <h4 id="asynchandlechange">Async Handle change event listener :<code>handleChange</code></h4>
        <AsyncHandleChange />
        <h4 id="handleclick">Handle click event listener :<code>handleClick</code></h4>
        <HandleClick />
        <h4 id="toggleicon">Adding icon to toggle button (only for <code>IosToggle</code>):<code>ToggleIcon</code></h4>
        <p><code>ToggleIcon</code> can either be string or a react element (in case you want to use something like <code>{`<FontAwesome />`}</code>)</p>
        <ToggleIcon />
        <h4 id="onofficon">Adding on | off text: <code>onProps | offProps</code></h4>
        <OnOffIcon />
        <h4 id="onoffcolor">Customizing on | off text and background color : <code>onProps | offProps</code></h4>
        <OnOffColor />
        <div className="disclaimer">
          <p><strong>NOTE:</strong> The default width of all toggles are set to <code>60px</code> for the purpose of this demo using css</p>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js